import { render, staticRenderFns } from "./BoardSearch.vue?vue&type=template&id=7d311929&lang=pug"
import script from "./BoardSearch.vue?vue&type=script&lang=js"
export * from "./BoardSearch.vue?vue&type=script&lang=js"
import style0 from "./BoardSearch.vue?vue&type=style&index=0&id=7d311929&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports